function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  fill: "#183150",
  fillOpacity: .5,
  d: "M10.003 10A2.002 2.002 0 0 1 8 8c0-1.105.898-2 2.004-2 1.107 0 2.004.895 2.004 2s-.897 2-2.004 2zm0-6A4.001 4.001 0 0 0 6 8c0 2.21 1.793 4 4.003 4a4.001 4.001 0 0 0 2.831-6.828A4.005 4.005 0 0 0 10.004 4zm0 10c-3.17 0-6.17-2.29-7.9-6 1.73-3.71 4.73-6 7.9-6s6.171 2.29 7.902 6c-1.73 3.71-4.731 6-7.902 6zm9.92-6.4c-2.02-4.69-5.82-7.6-9.92-7.6s-7.9 2.91-9.92 7.6a1 1 0 0 0 0 .8c2.02 4.69 5.82 7.6 9.92 7.6s7.9-2.91 9.92-7.6a1 1 0 0 0 0-.8z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/password.12ed60f0.svg";
export { SvgComponent as ReactComponent };